import { CheckCircle2 } from 'lucide-react';

/**
 * The listing's own words (MERCH-59): highlights, description and condition
 * notes, as plain text. Renders nothing when the listing has none. Kept in its
 * own file so the product page only mounts it (one line in design/product.jsx).
 */
export default function ListingNotes({ l }) {
  const highlights = Array.isArray(l.highlights) ? l.highlights : [];
  if (!highlights.length && !l.description && !l.condition_notes) return null;
  return (
    <div className="space-y-2 text-sm">
      {highlights.length ? (
        <ul className="space-y-1" aria-label="Highlights">
          {highlights.map((h) => (
            <li key={h} className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-success-600" aria-hidden="true" />
              <span>{h}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {l.description ? <p className="whitespace-pre-line opacity-90">{l.description}</p> : null}
      {l.condition_notes ? (
        <p className="whitespace-pre-line opacity-80">
          <span className="font-semibold">Condition notes: </span>
          {l.condition_notes}
        </p>
      ) : null}
    </div>
  );
}
